<template>
	<div id="main">
		<div class="Box">
			<a target="_blank" href="http://scsf.hydrogroup.cn/">
				<div class="item item1">
					<div class="itembg animate__animated animate__fadeInDown">
						<h2 class="qxTitle title-common">气象大数据</h2>
					</div>
				</div>
			</a>
			<a target="_blank" href="http://dask.hydrogroup.cn/">
				<div class="item item2">
					<div class="itembg animate__animated animate__fadeInUp">
						<h2 class="skTitle title-common">水库</h2>
					</div>
				</div>
			</a>
			<a target="_blank" href="http://scsf.hydrogroup.cn/">
				<div class="item item3">
					<div class="itembg animate__animated animate__fadeInDown">
						<h2 class="zhTitle title-common">多灾害综合</h2>
						<span class="boxShdow"></span>
					</div>
				</div>
			</a>
			<a target="_blank" href="http://shuiwu.hydrogroup.cn">
				<div class="item item4">
					<div class="itembg animate__animated animate__rotateInDownRight">
						<h2 class="swTitle title-common">智慧</h2>
					</div>
				</div>
			</a>
			<a target="_blank" href="http://huanbao.hydrogroup.cn">
				<div class="item item5">
					<div class="itembg animate__animated animate__fadeInLeft">
						<h2 class="hbTitle title-common">智慧环保</h2>
					</div>
				</div>
			</a>
			<a target="_blank" href="http://shuiwu.hydrogroup.cn">
				<div class="item item6">
					<div class="itembg animate__animated animate__fadeInRight">
						<h2 class="slTitle title-common">智慧水利</h2>
					</div>
				</div>
			</a>
			<a target="_blank" href="http://ganzhou.hydrogroup.cn">
				<div class="item item7">
					<div class="itembg animate__animated animate__fadeInUp">
						<h2 class="gsTitle title-common">智慧</h2>
					</div>
				</div>
			</a>
		</div>
	</div>
</template>

<script>
	import '../../assets/js/vanilla-tilt.js';

	export default {
		methods: {
			initVanillaTilt() {
				const classNames = ["item1", "item2", "item3", "item4", "item5", "item6", "item7"];
				classNames.forEach(className => {
					const element = document.querySelector(`.${className}`);
					if (element) {
						VanillaTilt.init(element, {
							max: 25,
							speed: 400
						});
					}
				});
			}
		},
		mounted() {
			this.initVanillaTilt();
		}
	};
</script>

<style scoped="scoped">
	@font-face {
		font-family: "HYDaHeiJ";
		src: url("../../assets/font/HYDaHeiJ.ttf");
	}

	@font-face {
		font-family: "PingFang-SC-Semibold-2";
		src: url("../../assets/font/PingFang-SC-Semibold-2.ttf");
	}

	.title-common {
		font-size: 42px;
		font-family: PingFang-SC-Semibold-2;
		font-weight: 600;
		position: relative;
		top: 115px;
		left: 60px;
		text-align: left;
	}

	.qxTitle {
		width: 1em;
		height: 450px;
		color: #7D89FC;
		left: 107px;
		top: 128px;
	}

	.skTitle {
		width: 2em;
		height: 240px;
		color: #F85F9A;
		left: 63px;
		top: 128px;
	}

	.skTitle::after {
		content: '综合管理';
		width: 4em;
		display: block;

	}

	.zhTitle {
		width: 5em;
		height: 240px;
		color: #FD6666;
		left: 60px;
		top: 129px;
	}

	.zhTitle::after {
		content: '应急管理平台';
		width: 6em;
		display: block;
	}

	.swTitle {
		width: 2em;
		height: 200px;
		color: #FDB653;
		left: 48px;
		top: 129px;
	}

	.swTitle::after {
		content: '水务';
		width: 2em;
		display: block;
	}

	.hbTitle {
		width: 2em;
		height: 200px;
		color: #35CCF7;
		left: 63px;
		top: 109px;
	}

	.slTitle {
		width: 2em;
		height: 200px;
		color: #59E070;
		left: 48px;
		top: 109px;
	}

	.gsTitle {
		width: 2em;
		height: 84px;
		color: #71BCFF;
		left: 48px;
		top: 109px;
	}

	.gsTitle::after {
		content: '防汛';
		width: 5em;
		display: block;
	}

	#main {
		height: 100%;
		width: 100%;
		position: relative;
		overflow: hidden;
	}

	.item {
		float: left;
		margin: 7px;
	}

	.itembg {
		opacity: 0.5;
	}

	.Box {
		height: 775px;
		width: 1736px;
		position: absolute;
		left: 50%;
		top: 50%;
		margin-left: -868px;
		margin-top: -387.5px;
	}

	.Box>a {
		width: 400px;
		height: 774px;
	}

	.item1 {
		width: 400px;
		height: 774px;
	}


	.item1 .itembg {
		width: 400px;
		height: 774px;
		background: url(../../assets/img/qixiang.png);
	}

	.item2 {
		width: 320px;
		height: 394px;
	}

	.item2 .itembg {
		width: 320px;
		height: 394px;
		z-index: 2;
		border-radius: 33px;
		background: url(../../assets/img/shuiku.png);
	}

	.item3 {
		width: 640px;
		height: 394px;
	}

	.item3 .itembg {
		width: 640px;
		height: 394px;
		background: url(../../assets/img/hongshuijishanhongyujing.png);
	}

	.item4 {
		width: 320px;
		height: 394px;
	}

	.item4 .itembg {
		width: 320px;
		height: 394px;
		background: url(../../assets/img/shuiwu.png);
		background-size: 100% 100%;
	}

	.item5 {
		width: 638px;
		height: 358px;
	}

	.item5 .itembg {
		width: 638px;
		height: 358px;
		background: url(../../assets/img/huanbao.png);
	}

	.item6 {
		width: 322px;
		height: 358px;
	}

	.item6 .itembg {
		width: 322px;
		height: 358px;
		background: url(../../assets/img/shuili.png);
	}

	.item7 {
		width: 316px;
		height: 358px;

	}

	.item7 .itembg {
		width: 316px;
		height: 358px;
		background: url(../../assets/img/chengxiang.png);
		background-size: 100% 100%;
	}

	@media screen and (max-width:1680px) {
		.title-common {
			font-size: 30px;
			top: 100px;
			left: 55px;
		}

		.Box {
			height: 660px;
			width: 1280px;
			position: absolute;
			left: 50%;
			top: 50%;
			margin-left: -640px;
			margin-top: -330px;
		}

		.Box>a {
			width: 260px;
			height: 660px;
		}

		.item1 {
			width: 260px;
			height: 614px;
		}

		.item1 .itembg {
			width: 260px;
			height: 614px;
			background-size: 100% 100%;
		}

		.item2 {
			width: 260px;
			height: 300px;
		}

		.item2 .itembg {
			width: 260px;
			height: 300px;
			background-size: 100% 100%;
			z-index: 2;
		}

		.item3 {
			width: 420px;
			height: 300px;
		}

		.item3 .itembg {
			width: 420px;
			height: 300px;
			background-size: 100% 100%;
		}

		.item4 {
			width: 260px;
			height: 300px;
		}

		.item4 .itembg {
			width: 260px;
			height: 300px;
			background-size: 100% 100%;
		}

		.item5 {
			width: 420px;
			height: 300px;
		}

		.item5 .itembg {
			width: 420px;
			height: 300px;
			background-size: 100% 100%;
		}

		.item6 {
			width: 260px;
			height: 300px;
		}

		.item6 .itembg {
			width: 260px;
			height: 300px;
			background-size: 100% 100%;
		}

		.item7 {
			width: 260px;
			height: 300px;
		}

		.item7 .itembg {
			width: 260px;
			height: 300px;
			background-size: 100% 100%;
		}

	}

	@media screen and (max-width: 1240px) {
		.title-common {
			font-size: 24px;
			top: 90px;
			left: 50px;
		}

		.Box {
			height: 528px;
			width: 1024px;
			position: absolute;
			left: 50%;
			top: 50%;
			margin-left: -512px;
			margin-top: -264px;
		}

		.Box>a {
			width: 208px;
			height: 528px;
		}

		.item1 {
			width: 208px;
			height: 491.2px;
		}

		.item1 .itembg {
			width: 208px;
			height: 491.2px;
			background-size: 100% 100%;
		}

		.item2,
		.item4,
		.item6,
		.item7 {
			width: 208px;
			height: 240px;
		}

		.item2 .itembg,
		.item4 .itembg,
		.item6 .itembg,
		.item7 .itembg {
			width: 208px;
			height: 240px;
			background-size: 100% 100%;
		}

		.item3,
		.item5 {
			width: 336px;
			height: 240px;
		}

		.item3 .itembg,
		.item5 .itembg {
			width: 336px;
			height: 240px;
			background-size: 100% 100%;
		}
	}

	@media screen and (max-width: 1008px) {
		.title-common {
			font-size: 18px;
			top: 70px;
			left: 35px;
		}

		.Box {
			height: 396px;
			width: 784px;
			position: absolute;
			left: 50%;
			top: 50%;
			margin-left: -384px;
			margin-top: -198px;
		}

		.Box>a {
			width: 156px;
			height: 396px;
		}

		.item1 {
			width: 156px;
			height: 368.4px;
		}

		.item1 .itembg {
			width: 156px;
			height: 368.4px;
			background-size: 100% 100%;
		}

		.item2,
		.item4,
		.item6,
		.item7 {
			width: 156px;
			height: 180px;
		}

		.item2 .itembg,
		.item4 .itembg,
		.item6 .itembg,
		.item7 .itembg {
			width: 156px;
			height: 180px;
			background-size: 100% 100%;
		}

		.item3,
		.item5 {
			width: 252px;
			height: 180px;
		}

		.item3 .itembg,
		.item5 .itembg {
			width: 252px;
			height: 180px;
			background-size: 100% 100%;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/views/Main.vue